<main class="exported-inspection-wrapper">
  <h1 class="title">{{ 'ExportedInspection.Title' | i18next }}</h1>
  <div class="action-buttons">
    <doka-button color="clear" class="main-button" (click)="goToDashbord()">
      {{ 'ExportedInspection.BackToDashboard' | i18next }}</doka-button
    >
    <button mat-raised-button class="export-button" color="accent" (click)="exportInspection()">{{ 'ExportedInspection.ExportToCsv' | i18next }}</button>
  </div>
</main>
